import { selectPrepareQuestionnaire } from 'app/features/questionnaires/create/PrepareQuestionnaire/slice';
import { useSelector } from 'react-redux';
import AdditionalQuestionsAttachments from '../../AdditionalQuestions/attachments';
import BusinessInfoAttachments from '../../BusinessInfo/attachments';

import CorporationTrustAttachments from '../../Income/CorporationTrust/attachments';
import HomeSaleAttachments from '../../Income/HomeSale/attachments';
import InvestmentsAttachments from '../../Income/Investments/attachments';
import OtherIncomeAttachments from '../../Income/OtherIncome/attachments';
import PassiveIncomeAttachments from '../../Income/PassiveIncome/attachments';
import SelfEmploymentAttachments from '../../Income/SelfEmployment/attachments';
import WagesAttachments from '../../Income/Wages/attachments';
import TheBasicsAttachments from '../../PersonalDetails/TheBasics/attachments';
import SoleProprietorshipAttachments from '../../SoleProprietorship/attachments';
import SpouseAttachments from '../../SpouseIncome/attachments';
import TaxesDeductionsAttachments from '../../TaxesDeductions/attachments';

export interface IDocumentsChecklistProps {}

export default function DocumentsChecklist(props: IDocumentsChecklistProps) {
  const taxType = useSelector(selectPrepareQuestionnaire);

  return (
    <>
      {taxType.taxRequestType === 'individual' && (
        <>
          <TheBasicsAttachments />
          <CorporationTrustAttachments />
          <HomeSaleAttachments />
          <InvestmentsAttachments />
          <OtherIncomeAttachments />
          <PassiveIncomeAttachments />
          <SelfEmploymentAttachments />
          <WagesAttachments />
          <SpouseAttachments />
          <TaxesDeductionsAttachments />
        </>
      )}
      {taxType.taxRequestType === 'business' && (
        <>
          <BusinessInfoAttachments />
          <SoleProprietorshipAttachments />
          <AdditionalQuestionsAttachments />
        </>
      )}
    </>
  );
}
